/* et-scroll-reveal.js — shared IntersectionObserver reveal-on-scroll helper
   Ground truth: hooks/use-scroll-reveal.ts (Lumera React site).
   Elements with class "et-reveal" fade + translate up once they enter
   the viewport. Safe to include from multiple sections on the same page. */
(function () {
  if (window.__etScrollRevealInit) return;
  window.__etScrollRevealInit = true;

  function observe(scope) {
    var els = (scope || document).querySelectorAll('.et-reveal:not(.et-reveal--in)');
    if (!els.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('et-reveal--in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -60px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { observe(); });
  } else {
    observe();
  }

  document.addEventListener('shopify:section:load', function (e) { observe(e.target); });
})();
